import { render } from "./CampaignDetails.vue?vue&type=template&id=3b27c36a&scoped=true"
import script from "./CampaignDetails.vue?vue&type=script&lang=js"
export * from "./CampaignDetails.vue?vue&type=script&lang=js"

import "./CampaignDetails.vue?vue&type=style&index=0&id=3b27c36a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b27c36a"]])

export default __exports__